module.exports = __webpack_public_path__ + "img/b1.918a1e21.png";